RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const actionType = {
        close: {
            html: 'Close',
            className: 'btn btn-default',
            attributes: {
                type: 'button',
                'data-dismiss': 'modal'
            }
        },
        message: {
            tagName: 'div',
            attributes: {
                style: 'line-height: 34px;'
            },
            className: 'modal-action-message pull-left'
        },
        next: {
            html: 'Next',
            className: 'btn btn-primary'
        }
    };

    actionType.save = _.defaults({
        html: 'Save',
        attributes: function () {

            const me = this;
            const attrFcn = actionType.next.attributes;
            const attributes = (_.isFunction(attrFcn) ? attrFcn.apply(me, arguments) : {});
            return _.extend(attributes, {
                'data-dismiss': 'modal'
            });
        },
        events: {
            click: function (e) {

                const me = this;
                const errors = me.model.validate();
                if (_.isEmpty(errors)) {
                    const state = me.getOption('state');
                    state.triggerMethod('save');
                } else {
                    // don't dismiss the modal if we've got errors
                    e.stopPropagation();
                }
            }
        }
    }, actionType.next);


    const Action = Marionette.View.extend({
        tagName: 'button',

        initialize: function () {

            const me = this;
            const state = me.getOption('state');
            const stateEvents = me.getOption('stateEvents');

            if (state && stateEvents) {

                Marionette.bindEntityEvents(me, state, stateEvents);
            }
        },

        render: function () {

            const me = this;
            me.$el.html(me.getOption('html'));
            return me;
        }
    });

    const Actions = Marionette.CollectionView.extend({
        childViewOptions: function (model) {
            const options = _.omit(model.toJSON(), 'view');
            const action = actionType[options.type];
            return (action ? _.defaults(options, action) : options);
        },

        getChildView: function (model) {

            return (model.get('view') ? model.get('view') : Action);
        }
    });

    const createWizard = function (config) {

        const state = '0';
        const steps = _.result(config, 'steps');

        const Wizard = RivalIQ.apps.Dashboard.models.Wizard.extend({
            constructor: function (attrs, options) {
                const me = this;

                Backbone.Model.call(me, attrs, options);
            },

            getStepCount: function () {

                return _.size(steps);
            },
            getStep: function () {

                const me = this;
                return _.get(steps, me.get('state'));
            },
            View: RivalIQ.apps.Dashboard.views.Wizard,
            StateMachine: RivalIQ.apps.Dashboard.models.StateMachine.extend({
                initialState: state,
                events: {
                    'change:state': _.map(_.initial(steps), function (step, i) {

                        return [i.toString(), (i + 1).toString(), _.partial(_.identity, true)];
                    })
                }
            }),
            getDefaultActionsForStep: function (step) {

                const me = this;
                const model = me.model;
                const state = parseInt(me.controller.state) + 1;

                const nextModel = _.extend(new Backbone.Model(), {
                    validate: function () {

                        return (!_.isFunction(step.validator) || step.validator() ? null : ['error']);
                    }
                });

                nextModel.listenTo(model, 'change', _.bind(nextModel.trigger, nextModel, 'change', nextModel));

                const nextAction = {
                    state: me,
                    type: 'save',
                    className: [
                        actionType.next.className,
                        'pull-right'
                    ].join(' '),
                    model: nextModel
                };

                if (state < me.getStepCount()) {

                    _.extend(nextAction, {
                        type: 'next',
                        events: {
                            click: function () {
                                const me = this;

                                const errors = me.model.validate();
                                if (!_.isEmpty(errors)) {
                                    return;
                                }

                                model.trigger('change:state');
                            }
                        }
                    });
                }

                let previousAction;

                if (state > 1) {

                    previousAction = {
                        html: 'Previous',
                        className: 'btn btn-default pull-right',
                        events: {
                            click: function () {

                                const state = me.controller.state;
                                me.controller.state = (state - 1).toString();
                                me.controller.trigger('transition', state, state - 1);
                            }
                        }
                    };
                }

                let deleteAction;

                if (!model.isNew() && _.isFunction(me.onDelete)) {

                    deleteAction = _.defaults({
                        html: 'Delete',
                        className: 'btn btn-danger pull-left',
                        events: {
                            click: _.bind(me.triggerMethod, me, 'delete')
                        }
                    }, actionType.close);
                }

                return _.compact([
                    _.defaults({
                        html: 'Cancel',
                        className: [actionType.close.className, 'pull-left'].join(' ')
                    }, actionType.close),
                    deleteAction,
                    nextAction,
                    previousAction,
                    _.defaults({
                        className: 'modal-action-message text-center',
                        html: ['Step', state, 'of', me.getStepCount()].join(' ')
                    }, actionType.message)
                ]);
            },
            getActions: function () {

                const me = this;
                const step = me.getStep();
                const actions = me.getDefaultActionsForStep(step);
                return (_.isFunction(step.actions) ? step.actions(actions, me) : actions);
            }
        });

        return _.extend(new Wizard({
            state: state,
            views: _.reduce(steps, function (memo, step, i) {

                memo[i] = step;
                return memo;
            }, {})
        }), _.pick(config, 'model'));
    };

    views.ModalBackdropResizing = {
        events: {
            'shown.bs.modal': 'onShown',
            'hidden.bs.modal': 'onHidden'
        },

        checkHeightInterval: 200,

        getModal: function () {
            const me = this;
            return me.$el;
        },

        getModalBodyClientHeight: function () {
            const me = this;
            return me.body.el.clientHeight;
        },

        onShown: function () {
            const me = this;
            let previousHeight = me.getModalBodyClientHeight();

            me._heightTimeout = setTimeout(function checkHeight() {
                const currentHeight = me.getModalBodyClientHeight();

                if (previousHeight !== currentHeight) {
                    me.triggerMethod('handleUpdate');
                }

                previousHeight = currentHeight;

                me._heightTimeout = setTimeout(checkHeight, me.checkHeightInterval);
            }, me.checkHeightInterval);
            if (me.dashboardModel) {
                RivalIQ.views.SocialPostGrid.prototype.onRenderLoaded.apply(me, arguments);
            }
        },

        clearHeightTimeout: function () {
            const me = this;

            if (me._heightTimeout) {
                clearTimeout(me._heightTimeout);
            }
        },

        onDestroy: function () {
            const me = this;
            me.clearHeightTimeout();
        },

        onHidden: function () {
            const me = this;
            me.clearHeightTimeout();
            me.destroy();
        },

        onHandleUpdate: function () {
            const me = this;
            const modal = me.getModal();
            if (modal && modal.modal) {
                modal.modal('handleUpdate');
            }
        }
    };

    views.Modal = Marionette.LayoutView.mixin({
        regions: {
            header: '.modal-header',
            body: '.modal-body',
            footer: '.modal-footer'
        },

        mixins: {
            modalBackdropResizing: views.ModalBackdropResizing
        },

        attributes: {
            tabindex: -1
        },

        className: function () {

            const me = this;
            const model = me.model;
            return _.compact(['modal', 'fade', model.get('className')]).join(' ');
        },

        behaviors: {
            Information: {
                behaviorClass: RivalIQ.behaviors.Information
            }
        },

        ui: {
            information: '.fa-info-circle',
            title: '.modal-title',
            dismissBtn: '.modal-header button'
        },

        template: '#shellModalTemplate',

        serializeData: function () {

            const me = this;

            me.pickDefaultsFromContent();

            const data = me.model.toJSON();

            let size = '';

            if (data.size === 'extra-large') {

                size = 'modal-lg modal-xl';
            } else if (data.size === 'large') {

                size = 'modal-lg';
            }

            return _.defaults({
                size: size,
                header: _.exists(data.information),
                actions: _.exists(data.actions || data.contentWizard)
            }, data);
        },

        onBeforeShow: function () {

            const me = this;
            const wizard = me._wizard = me.createWizard();
            me.showBody(wizard);
            me.showFooter(wizard);
            me.updateHeader(wizard);
        },

        onShown: function () {

            const me = this;
            const model = me.model;
            const tracking = model.get('tracking');

            if (tracking) {

                RivalIQ.execute('tracking:push:auth', tracking.metric, tracking.options);
            }

            views.ModalBackdropResizing.onShown.apply(me, arguments);
        },

        onHidden: function () {

            const me = this;
            const wizard = me._wizard;

            views.ModalBackdropResizing.onHidden.apply(me, arguments);

            if (wizard) {

                wizard.triggerMethod('dismiss');
                wizard.destroy();
            }
        },

        showBody: function (wizard) {

            const me = this;
            const model = me.model;

            if (wizard) {
                wizard.runFilters('beforeFilters').done(function (result) {

                    if (!result) {

                        me.body.show(wizard.getWidgets());
                    }
                });
            } else if (model.get('contentView')) {

                me.body.show(model.get('contentView'));
            } else if (me.model.get('contentText')) {

                me.$('.modal-body').text(model.get('contentText'));
            } else if (me.model.get('contentHtml')) {

                me.$('.modal-body').html(model.get('contentHtml'));
            }
        },

        updateHeader: function (wizard) {
            const me = this;

            let information = me.model.toJSON().information;
            if (wizard) {
                const step = wizard.getStep();

                information = _.defaults(_.get(step, 'information') || {}, me.model.toJSON().information);
            }

            if (_.has(information, 'content')) {
                me.ui.information.show();
            } else {
                me.ui.information.hide();
            }

            if (information) {
                // used to render post tag in title
                if (information.showTitleAsHtml) {
                    me.ui.title.html(_.result(information, 'title'));
                } else {
                    me.ui.title.text(_.result(information, 'title'));
                }

                if (information.hideDismissBtn) {
                    me.ui.dismissBtn.hide();
                }
            }
        },

        showFooter: function (wizard) {

            const me = this;
            const model = me.model;
            const actions = (wizard ? wizard.getActions() : model.get('actions'));

            if (_.size(actions) > 0) {

                const view = new Actions({
                    collection: new Backbone.Collection(actions)
                });

                me.footer.show(view);
            }
        },

        pickDefaultsFromContent: function () {

            const me = this;
            const model = me.model;
            const contentView = model.get('contentView');

            const overrides = _.reduce(['title', 'subtitle', 'information'], function (memo, k) {

                memo[k] = _.result(contentView, k);
                return memo;
            }, {});

            model.set(_.pickBy(overrides, _.identity));
        },

        createWizard: function () {

            const me = this;
            const config = me.model.get('contentWizard');

            if (!config) {

                return;
            }

            const wizard = createWizard(config);

            wizard.listenTo(wizard, 'change:state', function () {
                me.updateHeader(wizard);
                me.showFooter(wizard);
                me.body.show(wizard.getWidgets());
            });

            return _.extend(wizard, _.pick(config, 'onDismiss', 'onSave', 'onDelete'));
        }
    });

});
